<!-- 
	This is the DataTables page, it uses the dashboard layout in: 
	"./layouts/Dashboard.vue" .
 -->

<template>
	<div>
		<!-- Searchable Datatable card -->
		<a-row type="flex" :gutter="24">
			<a-col :span="12" class="mb-24">
				<a-button type="primary" @click="$router.push('newrecipe')">NEW RECIPE</a-button>
			</a-col>
			<a-col :span="12" class="mb-24 text-right">
				<a-dropdown>
					<a-button class="ant-dropdown-link">
						FILTERS <a-icon class="ml-5" type="down" />
					</a-button>
					<a-menu slot="overlay">
						<a-menu-item key="0">
							<a href="http://www.alipay.com/">Completed</a>
						</a-menu-item>
						<a-menu-item key="2">
							<a href="http://www.taobao.com/">Saved</a>
						</a-menu-item>
					</a-menu>
				</a-dropdown>
				<a-button @click="csvExport(csvData)" class="ml-15">
					<i class="ni ni-archive-2 mr-5"></i> EXPORT CSV
				</a-button>

			</a-col>
		</a-row>
		<a-card :bordered="false" class="header-solid mb-24" :bodyStyle="{ padding: 0, paddingTop: '16px' }">
			<div class="mx-25">
				<a-row type="flex" :gutter="24">
					<a-col :span="24" :md="12">
						<a-select v-model="pageSize2" @change="onPageSize2Change" style="width: 70px">
							<a-select-option value="5">5</a-select-option>
							<a-select-option value="10">10</a-select-option>
							<a-select-option value="15">15</a-select-option>
							<a-select-option value="20">20</a-select-option>
							<a-select-option value="25">25</a-select-option>
						</a-select>
						<label for="" class="ml-10">entries per page</label>
					</a-col>
					<a-col :span="24" :md="12" class="text-right">
						<a-input-search placeholder="smart search" style="max-width: 200px;" v-model="query"
							@change="onSearchChange" />
					</a-col>
				</a-row>
			</div>

			<a-table class="mt-20" :columns="columns" :data-source="data" :pagination="{ pageSize: pageSize2, }" :key="id" :rowKey="record => record.id">

				<template slot="product" slot-scope="product, record">
					<a-button slot="actions" type="link" @click="generateDocumentRational(record.id, record.recipeName)" :disabled="isDownloading" :loading="isDownloading">
						<svg width="15" height="15" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path fill-rule="evenodd" clip-rule="evenodd"
								d="M3 17C3 16.4477 3.44772 16 4 16H16C16.5523 16 17 16.4477 17 17C17 17.5523 16.5523 18 16 18H4C3.44772 18 3 17.5523 3 17ZM6.29289 9.29289C6.68342 8.90237 7.31658 8.90237 7.70711 9.29289L9 10.5858L9 3C9 2.44772 9.44771 2 10 2C10.5523 2 11 2.44771 11 3L11 10.5858L12.2929 9.29289C12.6834 8.90237 13.3166 8.90237 13.7071 9.29289C14.0976 9.68342 14.0976 10.3166 13.7071 10.7071L10.7071 13.7071C10.5196 13.8946 10.2652 14 10 14C9.73478 14 9.48043 13.8946 9.29289 13.7071L6.29289 10.7071C5.90237 10.3166 5.90237 9.68342 6.29289 9.29289Z"
								fill="#111827" />
						</svg>
						Word
					</a-button>
				</template>

				<template slot="revenue" slot-scope="revenue, record">
					<a-button slot="actions" type="link" @click="generateDocumentSDS(record.id, record.recipeName)" :disabled="isDownloading">
						<svg width="15" height="15" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path fill-rule="evenodd" clip-rule="evenodd"
								d="M3 17C3 16.4477 3.44772 16 4 16H16C16.5523 16 17 16.4477 17 17C17 17.5523 16.5523 18 16 18H4C3.44772 18 3 17.5523 3 17ZM6.29289 9.29289C6.68342 8.90237 7.31658 8.90237 7.70711 9.29289L9 10.5858L9 3C9 2.44772 9.44771 2 10 2C10.5523 2 11 2.44771 11 3L11 10.5858L12.2929 9.29289C12.6834 8.90237 13.3166 8.90237 13.7071 9.29289C14.0976 9.68342 14.0976 10.3166 13.7071 10.7071L10.7071 13.7071C10.5196 13.8946 10.2652 14 10 14C9.73478 14 9.48043 13.8946 9.29289 13.7071L6.29289 10.7071C5.90237 10.3166 5.90237 9.68342 6.29289 9.29289Z"
								fill="#111827" />
						</svg>
						Word
					</a-button>
				</template>

				<template slot="label" slot-scope="label, record">
					<a-button slot="actions" type="link" @click="generateDocumentLabel(record.id, record.recipeName)" :disabled="isDownloading">
						<svg width="15" height="15" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path fill-rule="evenodd" clip-rule="evenodd"
								d="M3 17C3 16.4477 3.44772 16 4 16H16C16.5523 16 17 16.4477 17 17C17 17.5523 16.5523 18 16 18H4C3.44772 18 3 17.5523 3 17ZM6.29289 9.29289C6.68342 8.90237 7.31658 8.90237 7.70711 9.29289L9 10.5858L9 3C9 2.44772 9.44771 2 10 2C10.5523 2 11 2.44771 11 3L11 10.5858L12.2929 9.29289C12.6834 8.90237 13.3166 8.90237 13.7071 9.29289C14.0976 9.68342 14.0976 10.3166 13.7071 10.7071L10.7071 13.7071C10.5196 13.8946 10.2652 14 10 14C9.73478 14 9.48043 13.8946 9.29289 13.7071L6.29289 10.7071C5.90237 10.3166 5.90237 9.68342 6.29289 9.29289Z"
								fill="#111827" />
						</svg>
						Label
					</a-button>
				</template>

				<template slot="editBtn" slot-scope="row">


					<a-tooltip>
						<template slot="title">Edit Recipe</template>
						<a-button :data-id="row.key"
							@click="$router.push({ name: 'UpdateRecipe', params: { id: row.id } })">
							<a-icon type="edit" theme="outlined" /> Edit
						</a-button>
					</a-tooltip>


				</template>
				<template slot="deleteBtn" slot-scope="row">
					<a-tooltip>
						<template slot="title">Delete Recipe</template>
						<!-- <modalDelete @deleteHomeOwner="deleteHomeOwner" :row="row" /> -->
					</a-tooltip>
				</template>
			</a-table>
		</a-card>
		<!-- / Searchable Datatable card -->

	</div>
</template>

<script>


const columns = [
	{
		title: 'ID',
		dataIndex: 'id',
		sorter: (a, b) => a.key - b.key,
		sortDirections: ['descend', 'ascend'],
	},
	{
		title: 'Name',
		dataIndex: 'recipeName',
		sorter: (a, b) => a.key - b.key,
		sortDirections: ['descend', 'ascend'],
	},
	{
		title: 'Created',
		dataIndex: 'createdDate',
		sorter: (a, b) => a.date.length - b.date.length,
		sortDirections: ['descend', 'ascend'],
		customRender: (text) => {
			return text.split(' ')[0];
		}
	},
	{
		title: 'Last Updated',
		dataIndex: 'updatedDate',
		sorter: (a, b) => a.date.length - b.date.length,
		sortDirections: ['descend', 'ascend'],
		customRender: (text) => {
			return text.split(' ')[0];
		}
	},
	{
		title: 'STATUS',
		dataIndex: 'recipeStatus',
		sorter: (a, b) => stringSorter(a, b, 'recipeStatus'),
		sortDirections: ['descend', 'ascend'],
	},
	{
		title: 'CUSTOMER',
		dataIndex: 'customerName',
		sorter: (a, b) => stringSorter(a, b, 'customerName'),
		sortDirections: ['descend', 'ascend'],
	},
	{
		title: 'CREATED BY',
		dataIndex: 'createdBy',
		sorter: (a, b) => stringSorter(a, b, 'createdby'),
		sortDirections: ['descend', 'ascend'],
	},
	{
		title: 'Rational',
		dataIndex: 'product',
		scopedSlots: { customRender: 'product' },
	},
	{
		title: 'SDS',
		dataIndex: 'revenue',
		scopedSlots: { customRender: 'revenue' },
	},
	{
		title: 'Label',
		dataIndex: 'label',
		scopedSlots: { customRender: 'label' },
	},
	{
		title: 'Actions',
		scopedSlots: { customRender: 'editBtn' },
	},
];

import { mapState } from 'vuex'
const data = [];
export default {
	computed: {
		...mapState('associations', ['associations'])
	},
	components: {

	},
	data() {
		return {
			// Second table's list of columns.
			columns,

			data,

			// First table's number of rows per page.
			pageSize: 10,

			// Second table's number of rows per page.
			pageSize2: 10,

			// Second table's search query.
			query: '',

			isDownloading: false,
		}
	},
	methods: {
		// Event handler for first table's size change.
		onPageSizeChange() {
			this.pageSize = parseInt(this.pageSize);
		},

		// Event handler for second table's size change.
		onPageSize2Change() {
			this.pageSize2 = parseInt(this.pageSize2);
		},

		test(id) {
			console.log('===============')
			console.log(id)
			console.log('===============')
		},

		// Event handler for second table's search.
		onSearchChange() {
			if (this.query.length > 0) {
				this.data = this.data.filter((row) => {
					for (const key in row) {
						if (String(row[key]).toLowerCase().indexOf(this.query.toLowerCase()) > -1) {
							return true;
						}
					}
					return false;
				});
			}
			else {
				this.data = this.associations;
			}
		},

		async generateDocumentRational(id, recipeName) {
			this.isDownloading = true;
			this.$store.dispatch("WordDocs/getRational", { id: id, recipeName: recipeName }).then(() => {
				this.isDownloading = false;
			});
		},

		async generateDocumentSDS(id, recipeName) {
			this.isDownloading = true;
			this.$store.dispatch("WordDocs/getSDS", { id: id, recipeName: recipeName }).then(() => {
				this.isDownloading = false;
			});
		},

		async generateDocumentLabel(id, recipeName) {
			this.isDownloading = true;
			this.$store.dispatch("WordDocs/getLabel", { id: id, recipeName: recipeName }).then(() => {
				this.isDownloading = false;
			});
		},

	},

	computed: {
		user: {
			get() {
				return this.$store.state.user.user;
			}
		},
		recipes: {
			get() {
				return this.$store.state.recipes.recipes;
			}
		},
	},
	created() {
		this.$store.dispatch('recipes/getAll').then(() => {
			this.data = this.recipes;
		});
	}
}
</script>

<style lang="scss"></style>